exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.product-datasheet-box {\n  background-color: #fff;\n  border-radius: 5px;\n  padding: 0px 10px;\n@media (max-width: 992px) {\n    border: 1px solid #b3b3b3;\n}\n}\n.product-datasheet {\n  width: 100%;\ntr {\n    border-bottom: 1px solid #b3b3b3;\n}\ntr:last-of-type {\n    border: none;\n}\nth,\n  td {\n    padding: 10px 0;\n    color: #000;\n}\n}\n", ""]);

// exports
